var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#38b2ac",
    d: "m23.56,10.93l-10.5,-10.5a1.54,1.54 0 0 0 -2.12,0l-2,2a0.5,0.5 0 0 0 0,0.71l1.8,1.86a0.5,0.5 0 0 0 0.54,0.11a2,2 0 0 1 2.72,1.89a2,2 0 0 1 -0.15,0.74a0.5,0.5 0 0 0 0.11,0.54l1.76,1.72a0.5,0.5 0 0 0 0.54,0.11a2,2 0 1 1 -1.26,1.89a2,2 0 0 1 0.14,-0.71a0.5,0.5 0 0 0 -0.11,-0.53l-1.68,-1.69a0.5,0.5 0 0 0 -0.85,0.35l0,5.28a0.5,0.5 0 0 0 0.3,0.46a2,2 0 1 1 -1.6,0a0.5,0.5 0 0 0 0.3,-0.46l0,-5.42a0.5,0.5 0 0 0 -0.3,-0.46a2,2 0 0 1 -1.06,-2.56a0.5,0.5 0 0 0 -0.14,-0.53l-1.81,-1.85a0.5,0.5 0 0 0 -0.71,0l-7,7a1.5,1.5 0 0 0 0,2.12l10.5,10.51a1.5,1.5 0 0 0 2.12,0l10.5,-10.51a1.5,1.5 0 0 0 0,-2.12l-0.04,0.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitIcon);
export default __webpack_public_path__ + "static/media/gitIcon.0e32395495f3ca699deb5e3617cd2b2d.svg";
export { ForwardRef as ReactComponent };